import { createSelector } from '@ngrx/store';
import { selectCompanyPageState } from '../index';

export const selectCompanyStoreState = createSelector(selectCompanyPageState, (s) => s.companyStore);

export const selectStores = createSelector(selectCompanyStoreState, (s) => s.stores);

export const selectStoreUuid = createSelector(selectCompanyStoreState, (s) => s.selectedStoreUuid as string);

export const selectCurrentStore = createSelector(selectStores, selectStoreUuid, (stores, storeUuid) => {
  return stores.find((s) => s.uuid === storeUuid);
});
